function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.312 4.25c.057.142.087.295.088.45V8a4.998 4.998 0 00-.973-.572V5.623h-4.03a.458.458 0 01-.34-.142.532.532 0 01-.147-.358V1H1.838a.448.448 0 00-.328.146.52.52 0 00-.136.354v13a.533.533 0 00.138.356.436.436 0 00.332.144H6.4c.284.379.62.716 1 1H1.838a1.366 1.366 0 01-1.006-.43A1.586 1.586 0 01.4 14.5v-13C.413.66 1.054-.01 1.834 0h6.984a1.11 1.11 0 01.804.34l3.445 3.534c.104.106.187.234.245.376zm-.922.355c-.003-.01-.005-.019-.011-.025L8.935 1.049c-.009-.009-.02-.012-.03-.015-.006-.001-.013-.003-.019-.006v3.595h3.51a.074.074 0 01-.006-.018z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4 16a4 4 0 100-8 4 4 0 000 8zm1.854-5.854a.5.5 0 010 .708L11.107 12l1.147 1.146a.5.5 0 01-.707.708L10.4 12.707l-1.146 1.147a.5.5 0 01-.708-.708L9.693 12l-1.147-1.146a.5.5 0 01.708-.708l1.146 1.147 1.146-1.147a.5.5 0 01.708 0z"
});

function SvgDicardDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgDicardDraft;